import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { Text } from '@fluentui/react';
import instructionsImg1 from '@shared/images/power-bi-instructions-1.png';
import instructionsImg2 from '@shared/images/power-bi-instructions-2.png';
import instructionsImg3 from '@shared/images/power-bi-instructions-3.png';
import instructionsImg4 from '@shared/images/power-bi-instructions-4.png';
const InstructionsModalStep = ({ step, text, imageSrc })=>{
    return /*#__PURE__*/ _jsxs("div", {
        className: "instructionsStep",
        children: [
            /*#__PURE__*/ _jsx("img", {
                className: "instructionsImg",
                src: imageSrc
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "instructionsStepText",
                children: [
                    /*#__PURE__*/ _jsxs(Text, {
                        className: "instructionsNumber",
                        children: [
                            step,
                            ". "
                        ]
                    }),
                    text
                ]
            })
        ]
    });
};
export const InstructionsModalBody = ({ context })=>{
    const stepsMap = {
        stepOne: {
            text: /*#__PURE__*/ _jsx(Text, {
                children: context.loc('PowerBIVisual_Instructions_1')
            }, "stepOne"),
            image: instructionsImg1
        },
        stepTwo: {
            text: /*#__PURE__*/ _jsx(Text, {
                children: context.loc('PowerBIVisual_Instructions_2')
            }, "stepTwo"),
            image: instructionsImg2
        },
        stepThree: {
            text: /*#__PURE__*/ _jsx("span", {
                dangerouslySetInnerHTML: {
                    __html: context.locParams('PowerBIVisual_Instructions_3', [
                        `<span class='instructionsOpen'>${context.loc('PowerBIVisual_Instructions_Open')}</span>`
                    ])
                }
            }, "stepThree"),
            image: instructionsImg3
        },
        stepFour: {
            text: /*#__PURE__*/ _jsx(Text, {
                children: context.loc('PowerBIVisual_Instructions_4')
            }, "stepFour"),
            image: instructionsImg4
        }
    };
    return /*#__PURE__*/ _jsx("div", {
        className: "instructionsStepsContainer",
        children: Object.keys(stepsMap).map((key, step)=>/*#__PURE__*/ _jsx(InstructionsModalStep, {
                step: step + 1,
                text: stepsMap[key].text,
                imageSrc: stepsMap[key].image
            }, key))
    });
};
